import React from 'react';
import classnames from 'classnames';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import { getCoverImageFile } from '../../../DeviationViews/Thumb/helpers';
import s from './Journal.scss';
var JournalStageBackground = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var preview = getCoverImageFile({
        deviation: deviation,
        width: width,
        height: height,
        allowHuge: true,
    });
    return preview ? (React.createElement(BackgroundImage, { src: preview.src, className: classnames(!isFullscreen && s['background']), imageClassName: s['background-image'] })) : (React.createElement(EmptyBackground, { className: classnames(!isFullscreen && s['background']) }));
};
JournalStageBackground.displayName = 'JournalStageBackground';
export default JournalStageBackground;
//# sourceMappingURL=Journal.js.map